import { Parallax } from 'ui/components';

export const ParallaxFeature: React.FC<Content.Parallax> = ({
	content,
	settings,
}) => {
	return (
		<Parallax
			{...content?.properties}
			{...settings?.properties}
		/>
	);
};